import * as $ from 'jquery'
import store from '../../../js/store';
import 'lity';

store.$app.on('click','.exhibitor__link',function(e) {
  e.preventDefault();

  const element = this.getAttribute('href'),
        $elem = $(element).prop('content')
        node = $($elem).clone(),
        embed = $('<div>').append(node).html();

  lity(embed);
});
